var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "power-area" },
    [
      _c(
        "Mentionable",
        {
          attrs: {
            keys: ["@"],
            items: _vm.items,
            "insert-space": true,
            "map-insert": _vm.mapInsert,
            placement: "bottom-start"
          },
          on: {
            open: function($event) {
              return _vm.loadIssues()
            },
            search: function($event) {
              return _vm.loadIssues($event)
            },
            onApply: _vm.addMention
          },
          scopedSlots: _vm._u([
            {
              key: "no-result",
              fn: function() {
                return [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.mentions_loading ? "Loading..." : "No result"
                      ) +
                      "\n        "
                  )
                ]
              },
              proxy: true
            },
            {
              key: "item-@",
              fn: function(ref) {
                var item = ref.item
                return [
                  _c("div", { staticClass: "issue" }, [
                    _c("span", { staticClass: "dim" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(item.label) +
                          "\n                "
                      )
                    ])
                  ])
                ]
              }
            }
          ])
        },
        [
          _c("textarea-autosize", {
            ref: "myTextarea",
            attrs: {
              maxlength: _vm.maxlength,
              placeholder: _vm.placeholder,
              value: _vm.text,
              "min-height": 30,
              "max-height": 350
            },
            on: { input: _vm.setText }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }